<template>
  <div :class="{ webFoot: true, 'webFoot-hidden': isHiddenFoot }"  >
    <div class="wf-model">
      <div class="wf-model-right" v-if="this.$parent.isorder">
        <!-- 二维码 -->
        <img class="wf-model-right-code-img" :src="wf_code" />
        <div class="wf-model-right-prompt font-14">微信扫码关注公众号</div>
      </div>

      <!-- 备案号 -->
      <div class="wf-model-bottom font-14">
        <div v-if="this.$parent.isorder">2022 ©广东新彩航印刷有限公司</div>
        <img class="wf-model-bot-icon" src="@/assets/icon/ghs.png" />
        <div class="wf-model-bot-bn" v-if="this.$parent.isorder"><a href="https://beian.miit.gov.cn">	粤ICP备19139271号-1</a></div>
        <div class="wf-model-bot-bn" v-else><a href="https://beian.miit.gov.cn">	粤ICP备19139271号-2</a></div>
      </div>
      <div style="margin-left:80px" class="neirong" v-if="this.$parent.isorder">
		<div style="display:flex;mine-height:20px;margin-top:30px">
			<div style="height:20px;width:20px;background:#fff;color:rgba(0, 0, 0, 0.65);font-weight:bold;border-radius:10px;text-align:center;line-height:20px">T</div>&nbsp;&nbsp;<span style="color:#fff">0757-85101650</span>
		</div>
		<div style="display:flex;mine-height:20px;margin-top:10px">
			<div style="height:20px;width:20px;background:#fff;color:rgba(0, 0, 0, 0.65);font-weight:bold;border-radius:10px;text-align:center;line-height:20px">Q</div>&nbsp;&nbsp;<span style="color:#fff">800180939</span>
		</div>
		<div style="display:flex;mine-height:20px;margin-top:10px">
			<div style="height:20px;width:20px;background:#fff;color:rgba(0, 0, 0, 0.65);font-weight:bold;border-radius:10px;text-align:center;line-height:20px">W</div>&nbsp;&nbsp;<span style="color:#fff">http://www.yin2015.com</span>
		</div>
		<div style="display:flex;mine-height:20px;margin-top:10px">
			<div style="height:20px;width:20px;background:#fff;color:rgba(0, 0, 0, 0.65);font-weight:bold;border-radius:10px;text-align:center;line-height:20px">A</div>&nbsp;&nbsp;<span style="color:#fff">广东省佛山市南海区和顺顺福东路1号宝鼎智造产业园6号楼首层</span>
		</div>
      </div>
    </div>
  </div>
</template>
<script>
import qrCode from "@/assets/public/off_code.jpg";

export default {
  name: "webFoot",
  props: {
    isHiddenFoot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userinfo:{head:true},
      wf_list: [
        [
          { id: "wfl01", name: "关于彩航" },
          { id: "wfl02", name: "公司简介" },
          { id: "wfl03", name: "联系我们" },
          { id: "wfl04", name: "合作指南" },
        ],
        [
          { id: "wfl05", name: "订购指南" },
          { id: "wfl06", name: "下单必读" },
          { id: "wfl07", name: "下单流程" },
          { id: "wfl08", name: "自取网点" },
          { id: "wfl22", name: "送货上门" },
        ],
        [
          { id: "wfl09", name: "售后服务" },
          { id: "wfl10", name: "退换货条款" },
          { id: "wfl11", name: "发票须知" },
          { id: "wfl12", name: "投诉建议" },
          { id: "wfl14", name: "发律申明" },
        ],
        [
          { id: "wfl14", name: "帮助中心" },
          { id: "wfl15", name: "常见问题" },
          { id: "wfl16", name: "忘记密码" },
          { id: "wfl17", name: "友情链接" },
        ],
      ],
      wf_code: qrCode,
      wf_phoneNumber: "0757-85101650",
      wf_time: "周一至周日 10:30~20:30",
    };
  },
   mounted() {
    this.userinfo = this.STORAGE.get("g_userInfo");
  },
};
</script>
<style scoped>
@media only screen and (min-width: 480px) {
  .webFoot {
    background: rgba(35, 40, 48, 0.9);
    width: 100%;
  }
  .webFoot-hidden {
    height: 0;
    overflow: hidden;
  }
  .wf-model {
    display: flex;
    /* width:100%; */
        justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px calc((100% - 1280px) / 2);
    /* display:flex; flex-wrap:wrap; justify-content:center;
	box-sizing:border-box; padding:30px 0 24px 0; */
  }
  .wf-model-view {
    width: 180px;
    margin: 10px 0;
    color: #ffffff;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }
  .wf-model-view-title {
    width: 100%;
    text-align: center;
    margin-bottom: 6px;
    border-right: 1px solid #aaa;
  }
  .wf-model-view-value {
    margin: 4px 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease-in-out 0s;
  }
  .wf-model-right {
    width: 200px;
    margin: 10px 0;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }
  .wf-model-right-code {
    background: #ffffff;
    width: 100px;
    height: 100px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
  }
  .wf-model-right-code-img {
    /* width:100%; height:100%; */
    width: 160px;
    height: 160px;
  }
  .wf-model-right-prompt {
    color: #ffffff;
    margin: 4px 0 0 0;
  }
  .wf-model-right-phone {
    margin: 4px 0 0 0;
  }
  .wf-model-right-time {
    color: #777;
  }
  .wf-model-bottom {
    font-size: 20px;
    margin: 10px 0;
    color: #ffffff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .wf-model-bot-icon {
    width: 16px;
    height: 16px;
    margin: 0 0 0 30px;
  }
  .wf-model-bot-bn{
    text-align: center;
    
  }
}
@media only screen and (max-width: 480px) {
  .neirong{
        display: none;
  }
  .webFoot {
    background: rgba(35, 40, 48, 0.9);
    width: 100%;
  }
  .webFoot-hidden {
    height: 0;
    overflow: hidden;
  }
  .wf-model {
    display: flex;
  }
  .wf-model-view {
    display: none;
  }
  .wf-model-view-title {
    width: 100%;
    text-align: center;
    margin-bottom: 6px;
    border-right: 1px solid #aaa;
  }
  .wf-model-view-value {
    margin: 4px 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease-in-out 0s;
  }
  .wf-model-right {
    display: none;
  }
  .wf-model-right-code {
    background: #ffffff;
    width: 100px;
    height: 100px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
  }
  .wf-model-right-code-img {
    width: 100%;
    height: 100%;
  }
  .wf-model-right-prompt {
    color: #ffffff;
    margin: 4px 0 0 0;
  }
  .wf-model-right-phone {
    margin: 4px 0 0 0;
  }
  .wf-model-right-time {
    color: #777;
  }
  .wf-model-bottom {
    width: 100%;
    color: #ffffff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .wf-model-bot-icon {
    width: 16px;
    height: 16px;
    margin: 0 0 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/webFoot.vue